<template>
    <Loading
        :is-loading="isLoading"
        :text="processingText"
    />
</template>
<script>
import { reactive, toRefs } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { postCheck } from '@/apis/confirmAddrPhoneEmail';
import Loading from '@/components/Loading.vue';
import routeName from '@/router/constant.js';

export default {
    components: {
        Loading,
    },
    setup() {
        const route = useRoute();
        const router = useRouter();
        const store = useStore();
        const data = reactive({
            isLoading: true,
            processingText: '登入檢核中...',
        });

        const ssoLogin = (data) => {
            return postCheck(data).then((res) => {
                return res.data;
            });
        };

        const request = {
            inputData: route.query?.param
        };

        // 開始登入
        ssoLogin(request)
            .then(data => {
                if (data.onlineType) {
                    data.param = request.inputData;
                    store.dispatch('permissions/clearAll');
                    store.dispatch('permissions/setUserInfo', data);
                    router.push({ name: routeName.LETTER_LOGIN });
                } else {
                    window.location.href = data.redirectApply;
                }
            })
            .catch((e) => {
                router.push({ name: routeName.FORBIDDEN });
            })
            .finally(() => {
                data.isLoading = false;
            });

        return {
            ...toRefs(data),
        };
    },
};
</script>
